import { validateMMDDYYYY } from '../utils/dateUtils';

export const date = validateMMDDYYYY;
